import { cn } from "@/lib/utils";

export function StatCard({ label, value, hint, icon: Icon, accent, className, testId }) {
  return (
    <div
      data-testid={testId}
      className={cn(
        "rounded-2xl border border-border/60 bg-card p-4 md:p-6 shadow-[0_1px_2px_rgba(0,0,0,0.04)] hover:shadow-[0_8px_24px_rgba(0,0,0,0.06)] transition-shadow duration-300",
        className
      )}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="text-[10px] md:text-[11px] font-semibold uppercase tracking-widest text-muted-foreground leading-tight">
          {label}
        </div>
        {Icon && (
          <div className={cn("rounded-full p-1.5 md:p-2 shrink-0", accent ? "bg-primary/10 text-primary" : "bg-secondary text-muted-foreground")}>
            <Icon className="h-3.5 w-3.5 md:h-4 md:w-4" />
          </div>
        )}
      </div>
      <div className="mt-3 md:mt-4 text-2xl md:text-3xl font-semibold tracking-tight">{value}</div>
      {hint && <div className="mt-1 text-[11px] md:text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
}
